"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createOrderItem;
function createOrderItem() {
    var fixture = init();

    function init() {
        return {};
    }

    return {
        itemId: function itemId(_itemId) {
            fixture.itemId = _itemId;
            return this;
        },
        price: function price(_price) {
            fixture.price = _price;
            return this;
        },
        count: function count(_count) {
            fixture.count = _count;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/openrest4js/dist/openrest4js-fixtures/OrderItem.js
// module id = 1109
// module chunks = 0